var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88533 3.05219L10.948 5.11486M9.76033 2.17719C10.0339 1.90367 10.4048 1.75 10.7917 1.75C11.1785 1.75 11.5495 1.90367 11.823 2.17719C12.0965 2.45072 12.2502 2.8217 12.2502 3.20853C12.2502 3.59535 12.0965 3.96633 11.823 4.23986L3.79167 12.2712H1.75V10.1875L9.76033 2.17719Z",
    stroke: "#3F3F46",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.684b7dba7e85b7da2a974bf6238eb6c6.svg";
export { ForwardRef as ReactComponent };